import script from "./Landing.vue?vue&type=script&setup=true&lang=js"
export * from "./Landing.vue?vue&type=script&setup=true&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=48671163&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48671163"]])

export default __exports__